import { MenuItem } from "@mui/material";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import useDeleteDailyFormWorkOrder from "hooks/fleet/useDeleteDailyFormWorkOrder";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

export default function DeleteWorkOrderMenuItem(props: BitumioMenuItem<any>) {
  const { closeMenu, object } = props;
  const [deleteWorkOrder, { isSuccess }] = useDeleteDailyFormWorkOrder();

  const acceptFn = useCallback(async (): Promise<boolean> => {
    const { data } = await deleteWorkOrder({ variables: { id: object.id } });
    if (isSuccess(data)) {
      closeMenu();
      return true;
    } else {
      return false;
    }
  }, [deleteWorkOrder, object.id, isSuccess, closeMenu]);

  const cancelFn = useCallback(async () => {
    closeMenu();
    return true;
  }, [closeMenu]);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Are you sure you want to continue?"
        content="This work order will be deleted. Are you sure you want to continue?"
        acceptText="Delete Work Order"
      />
      <MenuItem onClick={() => setOpen(true)}>Delete</MenuItem>
    </>
  );
}
